// src/utils/auth.js

import { LOGIN_API } from "../config"

const getUserProfile = async (token) => {
  try {
    
    const urlWithQuery = `${LOGIN_API}?AUTH_USER_TOKEN=${token}`;
    const response = await fetch(urlWithQuery, {
      method: 'GET',
      credentials: 'include',
    });

    return response;
  } catch (error) {
    console.error('Error checking user login:', error);
    return null;
  }
};

export { getUserProfile };